/* src/app/components/datatable/datatable.component.css */
.sticky-header {
  position: sticky;
  top: 0;
}
.column.title-column {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--fg-3);
  cursor: pointer;
}
.column.title-column .sort-chevron {
  opacity: 0.55;
  margin-left: auto;
}
tr.filter-row th,
tbody tr:first-child th,
table > tr > th {
  background: var(--gray-50) !important;
  border-bottom: 2px solid var(--border) !important;
  border-top: none !important;
}
.table > tbody > tr:first-child > th,
.table > tr > th {
  background: var(--gray-50) !important;
  border-bottom: 2px solid var(--border-strong) !important;
}
.form-control {
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-size: 12px;
  padding: 4px 10px;
  height: 30px !important;
  color: var(--fg-2);
  background: var(--bg-surface);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  min-width: 100px;
}
.form-control:focus {
  border-color: var(--navy-600);
  box-shadow: 0 0 0 3px rgb(44 66 114 / 0.12);
  outline: none;
}
.form-control::placeholder {
  color: var(--fg-4);
}
.table-striped > tbody > tr:nth-of-type(odd) > td {
  background-color: var(--bg-surface) !important;
}
.table-striped > tbody > tr:nth-of-type(even) > td {
  background-color: var(--gray-50) !important;
}
.table tbody tr:last-child th {
  background: var(--navy-600) !important;
  color: var(--fg-on-navy) !important;
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  border-top: 1px solid var(--border) !important;
  padding: 8px 14px !important;
}
.table tbody td .btn-primary {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: var(--radius-xs);
}
.table tbody td .btn-outline-primary {
  font-size: 12px;
  padding: 3px 10px;
  border-radius: var(--radius-xs);
}
.row {
  margin-bottom: 8px;
  align-items: center;
}
.row > .col-xs-12 {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.row > .col-xs-12 > div:first-child {
  font-size: 12px;
  color: var(--fg-3);
  white-space: nowrap;
}
:host ::ng-deep .pagination {
  margin: 0;
  gap: 3px;
  display: flex;
}
:host ::ng-deep .pagination > li > a,
:host ::ng-deep .pagination > li > span {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm) !important;
  color: var(--fg-2);
  font-size: 12px;
  font-weight: 500;
  padding: 5px 11px;
  line-height: 1.4;
  transition:
    background 0.12s ease,
    border-color 0.12s ease,
    color 0.12s ease;
  background: var(--bg-surface);
  min-width: 32px;
  text-align: center;
}
:host ::ng-deep .pagination > li > a:hover {
  background: var(--gray-100);
  border-color: var(--border-strong);
  color: var(--navy-600);
  text-decoration: none;
}
:host ::ng-deep .pagination > .active > a,
:host ::ng-deep .pagination > .active > span,
:host ::ng-deep .pagination > .active > a:hover,
:host ::ng-deep .pagination > .active > span:hover {
  background: var(--navy-600);
  border-color: var(--navy-600);
  color: var(--fg-on-navy);
}
:host ::ng-deep .pagination > .disabled > a,
:host ::ng-deep .pagination > .disabled > span {
  background: var(--gray-50);
  border-color: var(--gray-100);
  color: var(--border-strong);
  cursor: not-allowed;
}
:host ::ng-deep .pagination-sm > li:first-child > a,
:host ::ng-deep .pagination-sm > li:first-child > span,
:host ::ng-deep .pagination-sm > li:last-child > a,
:host ::ng-deep .pagination-sm > li:last-child > span {
  border-radius: var(--radius-sm) !important;
}
.step-programmation,
.step-evaluation,
.step-execution {
  display: inline-block;
  padding: 4px 12px;
  border-radius: var(--radius-xs);
  color: var(--fg-on-navy) !important;
  font-weight: 600;
}
.step-programmation {
  background-color: var(--success);
}
.step-evaluation {
  background-color: var(--warning);
}
.step-execution {
  background-color: var(--navy-600);
}
.smallCell {
  width: 1px;
  white-space: nowrap;
}
th {
  text-align: left;
}
.table-loading-overlay {
  position: absolute;
  inset: 38px 0 0 0;
  background: rgb(255 255 255 / 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  backdrop-filter: blur(1px);
}
.table-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border);
  border-top-color: var(--navy-600);
  border-radius: 50%;
  animation: tableSpinnerRotate 0.7s linear infinite;
}
@keyframes tableSpinnerRotate {
  to {
    transform: rotate(360deg);
  }
}
.card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 8px 0;
}
@media (min-width: 480px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.data-card {
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border-left: 4px solid transparent;
  overflow: hidden;
}
.data-card__body {
  padding: 12px 16px;
}
.data-card__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px 0;
  border-bottom: 1px solid var(--gray-100);
  gap: 8px;
  min-height: 28px;
}
.data-card__row:last-child {
  border-bottom: none;
}
.data-card__label {
  font-size: 0.72rem;
  color: var(--fg-3);
  font-weight: 600;
  flex-shrink: 0;
  max-width: 45%;
  padding-top: 2px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.data-card__value {
  font-size: 0.85rem;
  color: var(--navy-600);
  text-align: right;
  word-break: break-word;
}
.data-card__actions {
  display: flex;
  gap: 8px;
  padding: 10px 16px;
  background: var(--gray-50);
  border-top: 1px solid var(--border);
  flex-wrap: wrap;
}
.data-card__actions .btn {
  flex: 1;
  font-size: 0.8rem;
  min-width: 70px;
}
.data-card--summary {
  border-left-color: var(--navy-600);
  background: var(--gray-50);
}
.data-card--summary .data-card__label,
.data-card--summary .data-card__value {
  font-weight: 700;
  color: var(--navy-600);
}
.data-card-empty {
  grid-column: 1 / -1;
  text-align: center;
  color: var(--fg-4);
  padding: 24px;
  font-size: 0.9rem;
}
@media (max-width: 767.98px) {
  :host ::ng-deep .pagination > li > a,
  :host ::ng-deep .pagination > li > span {
    padding: 9px 14px;
    min-width: 42px;
    min-height: 42px;
    font-size: 16px;
    line-height: 1.2;
  }
}
.mobile-filter-bar {
  margin-bottom: 10px;
}
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 9px 12px;
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.15s;
  -webkit-user-select: none;
  user-select: none;
}
.mobile-filter-toggle:has(+ .mobile-filter-panel) {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
  border-color: var(--navy-600);
}
.mobile-filter-toggle__left {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 500;
  color: var(--navy-600);
}
.mobile-filter-toggle__right {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--fg-4);
}
.mobile-filter-badge {
  background: var(--navy-600);
  color: var(--fg-on-navy);
  border-radius: var(--radius-md);
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
}
.mobile-filter-clear {
  font-size: 11px;
  color: var(--danger);
  cursor: pointer;
  padding: 2px 4px;
}
.mobile-filter-panel {
  background: var(--bg-surface);
  border: 1px solid var(--navy-600);
  border-top: none;
  border-radius: 0 0 var(--radius-md) var(--radius-md);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}
.mobile-filter-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.mobile-filter-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--fg-3);
  margin-bottom: 0;
}
.mobile-filter-active {
  border-color: var(--navy-600) !important;
  background-color: var(--gray-100) !important;
}
/*# sourceMappingURL=datatable.component.css.map */
